<template>
	<div class="resource-question margin-bottom-xs-2">
		<div
			class="question-text margin-bottom-xs-1"
			v-html="question.question"
		></div>
		<div v-if="question.question_type == 'write-text'">
			<div class="form-group margin-bottom-xs-2">
				<label class="label">Skriv ditt svar</label>
				<textarea
					v-model="question.user_answer.answer"
					rows="4"
					@keyup="
						setAnswer(
							question.question_id,
							null,
							question.user_answer.answer
						)
					"
				></textarea>
			</div>
		</div>
		<div v-if="question.question_type == 'select-answer'">
			<div class="margin-bottom-xs-2">
				<div class="row">
					<div
						class="col-12 col-md-6 margin-bottom-xs-1"
						v-for="answer in question.answers"
						:key="answer.id"
					>
						<a
							class="pem-btn pem-btn-block"
							href="#"
							@click.prevent="
								setAnswer(
									question.question_id,
									answer.answer_id,
									answer.answer
								)
							"
							:class="{
								'pem-btn-primary':
									question.user_answer.answer_id ==
									answer.answer_id,
								'pem-btn-secondary':
									question.user_answer.answer_id !=
									answer.answer_id
							}"
							v-html="answer.answer"
						></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ResourceQuestion",
	props: ["question"],
	data() {
		return {};
	},
	components: {},
	computed: {},
	methods: {
		setAnswer(questionId, answerId, answer) {
			this.question.user_answer.answer_id = answerId;
			this.question.user_answer.answer = answer;
		}
	},
	created() {}
};
</script>